import { render } from "./iconChat.vue?vue&type=template&id=9d44e6c8&scoped=true"
import script from "./iconChat.vue?vue&type=script&lang=ts"
export * from "./iconChat.vue?vue&type=script&lang=ts"

import "./iconChat.vue?vue&type=style&index=0&id=9d44e6c8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9d44e6c8"

export default script